<template>
  <payment-link-layout :hideSecurityWarningOnMobile="true" v-if="onboarding">
    <template v-slot:content v-if="hiddenPhone">
      <step-progress-bar
        class="mt-24"
        stepTitle="confirmação de identidade"
        :stepNumber="4"
        :stepSize="4"
      />

      <onboarding-confirmation-link
        class="mb-36"
        :hiddenPhone="hiddenPhone"
        :resendCounter="resendCounter"
        @resendConfirmationCode="handleOnboardingLink"
      />

    </template>
  </payment-link-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PaymentLinkLayout from '../../paymentLink/layout/PaymentLinkLayout.vue';
import OnboardingConfirmationLink from '../components/OnboardingConfirmationLink.vue';
import StepProgressBar from '../../paymentLink/components/StepProgressBar.vue';

export default {
  name: 'v2-onboarding-redirect-to-mobile',
  components: {
    PaymentLinkLayout,
    StepProgressBar,
    OnboardingConfirmationLink,
  },
  computed: {
    ...mapState('onboardingV2', ['isMobile', 'hiddenPhone', 'nextRoute', 'onboarding']),
  },
  data: () => ({
    resendCounter: 90,
    verifyStatus: null,
  }),
  methods: {
    ...mapActions('onboardingV2', ['getOnboardingLink', 'sendConfirmationCode']),
    async handleOnboardingLink() {
      if (this.resendCounter !== 0) return;
      await this.getOnboardingLink();
      this.resendCounter = 90;
      this.startResendCounter();
    },
    startResendCounter() {
      const resendInterval = setInterval(() => {
        this.resendCounter -= 1;
        if (this.resendCounter === 0) clearInterval(resendInterval);
      }, 1000);
    },
    async completedVerificationCode(securityCode) {
      this.verifyStatus = 'loading';

      const { success } = await this.sendConfirmationCode({ securityCode });
      this.verifyStatus = success ? 'success' : 'failure';

      if (success) {
        setTimeout(async () => {
          await this.$router.replace({
            name: this.nextRoute,
            query: this.$route.query,
          });
        }, 1000);
      }
    },
    handleBackspace() {
      this.verifyStatus = null;
    },
  },
  mounted() {
    this.startResendCounter();
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';
</style>
